(function () {
  const STORAGE_PREFIX = 'viewed-recently-count:';
  const ONE_DAY = 24 * 60 * 60 * 1000;
  const MIN_VIEWS = 250;
  const MAX_VIEWS = 700;

  function randomViewCount() {
    return Math.floor(Math.random() * (MAX_VIEWS - MIN_VIEWS + 1)) + MIN_VIEWS;
  }

  function getStoredValue(productId, now) {
    try {
      const storedValue = window.localStorage.getItem(`${STORAGE_PREFIX}${productId}`);
      if (!storedValue) return null;

      const parsedValue = JSON.parse(storedValue);
      if (
        parsedValue?.productId === productId &&
        Number.isInteger(parsedValue.value) &&
        Number.isInteger(parsedValue.timestamp) &&
        now - parsedValue.timestamp < ONE_DAY
      ) {
        return parsedValue.value;
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  function setStoredValue(productId, value, now) {
    try {
      window.localStorage.setItem(
        `${STORAGE_PREFIX}${productId}`,
        JSON.stringify({
          productId,
          value,
          timestamp: now,
        })
      );
    } catch (error) {
      // Keep the visible count working even if localStorage is unavailable.
    }
  }

  function getViewCount(productId) {
    const now = Date.now();
    const storedValue = getStoredValue(productId, now);

    if (storedValue !== null) {
      return storedValue;
    }

    const value = randomViewCount();
    setStoredValue(productId, value, now);
    return value;
  }

  function updateViewedRecentlyCounts() {
    document.querySelectorAll('[data-viewed-recently][data-product-id]').forEach((element) => {
      const productId = element.getAttribute('data-product-id');
      if (!productId) return;

      element.textContent = getViewCount(productId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateViewedRecentlyCounts);
  } else {
    updateViewedRecentlyCounts();
  }
})();
